import { render, staticRenderFns } from "./privacy.vue?vue&type=template&id=6ac5d60c&scoped=true&"
var script = {}
import style0 from "./privacy.vue?vue&type=style&index=0&id=6ac5d60c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac5d60c",
  null
  
)

export default component.exports